/**
 * author: Soumya Shreyas
 */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import Multiselect from "multiselect-react-dropdown";
import {
  Button,
  Modal,
  Form,
  Col,
  Row,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import { SCORINGOPERATOR } from "../../../../core/constants/common";
import Utils from "../../../../core/utilities/Utils";
import ErrorHandlingService from "../../../../core/service/ErrorHandlingService";

function ScoringMethod({
  t,
  formulaeType,
  riskParams,
  paramId,
  regulation,
  handleScoring,
  list,
}) {
  const [show, setShow] = useState(true);
  const [validated, setValidated] = useState(false);
  const handleClose = () => {
    setShow(false);
    handleScoring(false);
  };
  const [denominators, setDenominators] = useState(
    list.denominators ? list.denominators : null
  );
  const [denominatorOperation, setDenominatorOperation] = useState(
    list.denominatorOperation ? list.denominatorOperation : "NONE"
  );
  const [numerators, setNumerators] = useState(
    list.numerators ? list.numerators : null
  );
  const [numberChecked, setNumberChecked] = useState(
    list.averageDenominator ? true : false
  );
  const [avgDenominator, setAvgDenominator] = useState(
    list.averageDenominator ? list.averageDenominator : ""
  );

  const [numeratorOperation, setNumeratorOperation] = useState(
    formulaeType === "SUM" || formulaeType === "MULTIPLY"
      ? formulaeType === "SUM"
        ? "ADD"
        : formulaeType
      : list.numeratorOperation
        ? list.numeratorOperation
        : "NONE"
  );
  const [name, setName] = useState("");
  const [resultConfig, setResultConfig] = useState([]);
  const [score, setScore] = useState("");
  const [weightage, setWeightage] = useState("");
  const handleSave = (e) => {
    e.preventDefault();
    var avgValidation = true;
    if (numberChecked) {
      avgValidation = avgDenominator ? true : false;
    }
    if (numerators.length > 0 && avgValidation) {
      list.numeratorOperation = numeratorOperation;
      list.numerators = numerators;
      list.denominatorOperation = denominatorOperation;
      list.denominators = denominators;
      list.formulae = formulaeType;
      list.averageDenominator = numberChecked ? parseInt(avgDenominator) : null;
      saveScoringMethods(list, regulation);
    }

    setValidated(true);
  };
  const saveScoringMethods = (params, regId) => {
    RiskConfigService.editRiskParameter(regId, paramId, params)
      .then((response) => {
        if (response.status === 200) {
          //   (response.data.parent) ? handleSave(response.data.parent.id) : handleSave('');
          //   handleDiscard(true);
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setShow(false);
          handleScoring(false);
        }
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
  };

  const onSelectNumerator = (selectedList, selectedItem) => {
    setNumerators([...selectedList]);
  };

  const onRemoveNumerator = (selectedList, removedItem) => {
    setNumerators([...selectedList]);
  };
  const onSelectDenominator = (selectedList, selectedItem) => {
    setDenominators([...selectedList]);
  };

  const onRemoveDenominator = (selectedList, removedItem) => {
    setDenominators([...selectedList]);
  };

  const handleDenomChecked = (event) => {
    let val = event.currentTarget.checked;
    setNumberChecked(val);
  };
  return (
    <>
      <Modal
        show={formulaeType == 0 ? false : show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          < Modal.Title as="h5">{t("ScoreingMethodCalculation.label")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
            {/* {riskParams.map((input, index) => {
              return ( */}
            <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>
                  <OverlayTrigger
                    placement="top"
                    overlay={Utils.renderTooltip(t("Numerator.label"))}
                  >
                    <span>{t("RiskParameter.label")}</span>
                  </OverlayTrigger>
                </Form.Label>
                <Multiselect
                  options={riskParams}
                  onSelect={onSelectNumerator}
                  onRemove={onRemoveNumerator}
                  displayValue="name"
                  selectedValues={list.numerators}
                  placeholder=""
                  required
                />
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>{t("Operator.label")}</Form.Label>
                <Form.Select
                  defaultValue={numeratorOperation}
                  onChange={(e) => setNumeratorOperation(e.target.value)}
                  selected={numeratorOperation}
                  disabled={
                    formulaeType === "SUM" || formulaeType === "MULTIPLY"
                      ? "disabled"
                      : ""
                  }
                >
                  {SCORINGOPERATOR.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
            {formulaeType === "AVERAGE" || formulaeType === "PERCENTAGE" ? (
              <>
                <Row className="mb-3">
                  <Form.Group as={Col}>
                    <Form.Label>
                      <OverlayTrigger
                        placement="top"
                        overlay={Utils.renderTooltip(t("Denominator.label"))}
                      >
                        <span>{t("RiskParameter.label")}</span>
                      </OverlayTrigger>
                    </Form.Label>
                    <Multiselect
                      options={riskParams}
                      onSelect={onSelectDenominator}
                      onRemove={onRemoveDenominator}
                      displayValue="name"
                      selectedValues={list.denominators}
                      placeholder=""
                      disable={numberChecked ? true : false}
                    />
                  </Form.Group>

                  <Form.Group as={Col}>
                    <Form.Label>{t("Operator.label")}</Form.Label>
                    <Form.Select
                      defaultValue={denominatorOperation}
                      onChange={(e) => setDenominatorOperation(e.target.value)}
                      selected={denominatorOperation}
                      disabled={numberChecked ? "disabled" : ""}
                    >
                      {SCORINGOPERATOR.map(({ value, label }) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col}>
                    <div key="default-checkbox" className="mb-3">
                      <OverlayTrigger
                        placement="top"
                        overlay={Utils.renderTooltip(
                          t("UseNumberasdenominator.label")
                        )}
                      >
                        <Form.Check
                          type="checkbox"
                          id="default-checkbox"
                          label={t("UseNumberasdenominator.label")}
                          checked={numberChecked}
                          onChange={handleDenomChecked}
                        />
                      </OverlayTrigger>
                    </div>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col}>
                    {numberChecked && (
                      <input
                        type="number"
                        name="denomNumber"
                        className="form-control"
                        value={avgDenominator}
                        onChange={(e) => setAvgDenominator(e.target.value)}
                        required
                      />
                    )}
                  </Form.Group>
                </Row>
              </>
            ) : (
              ""
            )}

            {/* );
            })} */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          <Button variant="primary" onClick={handleSave} className="sbmBtn">
            {t("Create.label")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default withTranslation()(ScoringMethod);
